// extracted by mini-css-extract-plugin
export default {"geolocationMap":"UwXNWFDkuu12D21IlndC"};